import script from "./TheTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTabs.vue?vue&type=script&setup=true&lang=js"

import "./TheTabs.vue?vue&type=style&index=0&id=2c2fcc51&lang=scss"

const __exports__ = script;

export default __exports__